import { render, staticRenderFns } from "./TableContent.vue?vue&type=template&id=2ffe5a7b&"
import script from "./TableContent.vue?vue&type=script&lang=js&"
export * from "./TableContent.vue?vue&type=script&lang=js&"
import style0 from "./TableContent.vue?vue&type=style&index=0&id=2ffe5a7b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports